import styled, { CSSObject } from '@emotion/styled'

type Props = {
  firstName: string
  lastName: string
  email?: string
  contactNumber: string
}

const CollapsedPersonDetails = ({
  firstName,
  lastName,
  email,
  contactNumber
}: Props) => {
  return (
    <CollapsedDetails>
      <NameDetails>
        {firstName} {lastName}
      </NameDetails>
      <ContactDetails>
        {!!email && (
          <>
            <span>{email}</span>
            <DividingDot>{'•'}</DividingDot>
          </>
        )}
        <span>{contactNumber}</span>
      </ContactDetails>
    </CollapsedDetails>
  )
}

const CollapsedDetails = styled.span(
  (): CSSObject => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '2px'
  })
)

const NameDetails = styled.span(
  (): CSSObject => ({
    fontWeight: 500
  })
)
const ContactDetails = styled.span(
  ({ theme }): CSSObject => ({
    display: 'flex',
    flexDirection: 'column',

    [theme.mediaQueries.viewport7]: {
      flexDirection: 'row',
      gap: '4px'
    }
  })
)

const DividingDot = styled.span(
  ({ theme }): CSSObject => ({
    display: 'none',

    [theme.mediaQueries.viewport7]: {
      display: 'initial'
    }
  })
)

export default CollapsedPersonDetails
